import { Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import Header from "../../partials/header";
import { isJsonString } from "../../utils/setting";
import Loading from "../loading";
import { detailStyle } from "./styles";
export class pluginService extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plugin: {},
    };
  }
  async componentDidMount() {
    const _this = this;
    this.props.getPluginCategory();
    const { match } = this.props;
    let pluginKey = match.params.pluginKey;
    // Add script
    const script = document.createElement("script");
    script.src = `/js/plugin/${pluginKey}/index.js`;
    script.async = true;
    document.body.appendChild(script);
    // load plugin
    this.loading.startLoading();
    let result = await this.props.getOnePlugin({ pluginKey: pluginKey });
    this.loading.stopLoading();
    if (result.code === 1) this.setState({ plugin: result.data });
  }

  async componentWillReceiveProps(nextProps) {
    const { match } = nextProps;
    let pluginKey = match.params.pluginKey;
    if (!this.idAddedPlugin(pluginKey))
      this.props.history.push(`/plugin/${pluginKey}`);
    if (pluginKey !== this.props.match.params.pluginKey) {
      // // Add script
      const script = document.createElement("script");
      script.src = `/js/plugin/${pluginKey}/index.js`;
      script.async = true;
      document.body.appendChild(script);
      // load plugin
      this.loading.startLoading();
      let result = await this.props.getOnePlugin({ pluginKey: pluginKey });
      this.loading.stopLoading();
      if (result.code === 1) this.setState({ plugin: result.data });
    }
  }
  idAddedPlugin = (pluginKey) => {
    // true => added
    let { listPluginsService } = this.props;
    if (listPluginsService.length > 0) {
      // => API đã load xong
      return (
        listPluginsService.findIndex((item) => item.pluginKey === pluginKey) !==
        -1
      );
    }
    return true;
  };
  submitAddPlugin = async (plugin) => {
    this.loading.startLoading();
    await this.props.createPluginService({ pluginKey: plugin.key });
    this.loading.stopLoading();
  };
  submitRemovePlugin = async (plugin) => {
    this.loading.startLoading();
    let check = await this.props.removePluginService({ pluginKey: plugin.key });
    if (check.code === 1) this.props.history.push(`/plugin/${plugin.key}`);
    this.loading.stopLoading();
  };
  render() {
    const { t, classes } = this.props;
    let { plugin } = this.state;
    if (isJsonString(plugin.categoryId))
      plugin.categoryId = JSON.parse(plugin.categoryId);
    if (isJsonString(plugin.user)) plugin.user = JSON.parse(plugin.user);
    return (
      <>
        <Header
          session={t("plugin")}
          title={plugin.name}
          button={t("plugin_remove_power_up")}
          variant="contained"
          colorButton="secondary"
          actionButton={() => this.submitRemovePlugin(plugin)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <Paper className={classes.paper}>
          <div id="rootModule"></div>
        </Paper>
      </>
    );
  }
}

const mapState = (state) => ({
  currencyCode: state.setting.setting
    ? state.setting.setting.currencyCode
    : "VND",
  listPluginCategory: state.pluginCategory.listPluginCategory,
  listPluginsService: state.pluginServices.listPlugins,
});

const mapDispatch = (dispatch) => ({
  getPluginCategory: dispatch.pluginCategory.getPluginCategory,
  getOnePlugin: dispatch.plugin.getOnePlugin,
  createPluginService: dispatch.pluginServices.create,
  removePluginService: dispatch.pluginServices.remove,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(detailStyle, { withTheme: 0 })(pluginService)
  )
);
